import { useTranslation } from 'react-i18next';
import { MAIN_SITE_URL } from '@/data/categories';
import CategoryDropdown from '@/components/feature/CategoryDropdown';

const HERO_BG =
  'https://readdy.ai/api/search-image?query=Clean%20minimal%20product%20flat%20lay%20of%20fashion%20items%20with%20white%20sneakers%20folded%20sage%20green%20hoodies%20cream%20t-shirts%20and%20small%20accessories%20arranged%20neatly%20on%20a%20warm%20cream%20background%20soft%20natural%20lighting%20pastel%20amber%20accents%20editorial%20e-commerce%20photography%20high%20detail%20airy%20fresh%20aesthetic%20top%20down%20view&width=1600&height=900&seq=basetao-hero-01&orientation=landscape';

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section className="relative min-h-[620px] md:min-h-[720px] flex items-center justify-center overflow-hidden pt-16">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${HERO_BG})` }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50" />

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 py-20 text-center">
        <p className="animate-fade-in-up text-xs md:text-sm font-semibold tracking-[0.2em] uppercase text-accent-300 mb-5">
          {t('hero.eyebrow')}
        </p>
        <h1 className="animate-fade-in-up font-heading font-extrabold text-3xl md:text-5xl text-background-50 leading-tight mb-5">
          {t('hero.title')}
        </h1>
        <p className="animate-fade-in-up text-base md:text-lg text-background-50/85 max-w-2xl mx-auto leading-relaxed mb-8">
          {t('hero.subtitle')}
        </p>

        <div className="animate-fade-in-up flex flex-col sm:flex-row items-center justify-center gap-3 mb-8">
          <a
            href={MAIN_SITE_URL}
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 rounded-md bg-primary-500 text-background-50 px-6 py-3.5 text-sm font-semibold hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-table-line text-base" />
            </span>
            {t('hero.ctaPrimary')}
          </a>
          <a
            href={MAIN_SITE_URL}
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 rounded-md bg-background-50 text-foreground-900 px-6 py-3.5 text-sm font-semibold hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-shopping-bag-line text-base" />
            </span>
            {t('hero.ctaSecondary')}
          </a>
        </div>

        <div className="animate-fade-in-up max-w-sm mx-auto mb-6 text-left">
          <CategoryDropdown
            label={t('hero.dropdownLabel')}
            placeholder={t('hero.dropdownPlaceholder')}
            variant="light"
          />
        </div>

        <p className="animate-fade-in-up text-xs text-background-50/70">
          {t('hero.trust')}
        </p>
      </div>
    </section>
  );
}